import { render, staticRenderFns } from "./InsuranceAuthorizationPatientSelection.vue?vue&type=template&id=3d837d82&"
import script from "./InsuranceAuthorizationPatientSelection.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationPatientSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports